import { useColorModeValue } from "@chakra-ui/react";

export function useHoverColors() {
  const redHoverColor = useColorModeValue("#fc8181", "#943126");
  const yellowHoverColor = useColorModeValue("#fbd38d", "#b7791f");
  const noAlarmHoverColor = useColorModeValue("#9edaa8", "#1f3d27");

  return { redHoverColor, yellowHoverColor, noAlarmHoverColor };
}
